import { Coins } from "lucide-react";
import usePreciousMetals from "@/hooks/use-precious-metals";

function formatPrice(value) {
  if (value == null) return "—";
  return `₹${Number(value).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
}

export default function PreciousMetalsWidget() {
  const { items = [], updated_at: updatedAt } = usePreciousMetals();

  return (
    <section className="bg-white border border-[#E2E8F0]" data-testid="precious-metals-widget">
      <div className="px-4 py-3 flex items-center justify-between border-b border-[#E2E8F0] bg-slate-50">
        <h3 className="cat-tag text-brand-blue">Gold &amp; Silver</h3>
        <Coins className="w-4 h-4 text-amber-600" />
      </div>
      <div className="divide-y divide-[#E2E8F0] px-4">
        {items.length ? items.map(item => (
          <div key={item.metal} className="py-3">
            <div className="flex items-center justify-between gap-3">
              <div className="text-sm font-semibold text-[#0F172A]">{item.label}</div>
              <div className="text-[0.65rem] text-[#64748B]">per gram</div>
            </div>
            <div className="grid grid-cols-2 gap-3 mt-2">
              <div>
                <div className="text-[0.65rem] text-[#64748B]">Buy (incl. GST)</div>
                <div className="text-sm font-semibold text-[#0F172A]">{formatPrice(item.final_buy_price ?? item.buy)}</div>
              </div>
              <div>
                <div className="text-[0.65rem] text-[#64748B]">Sell</div>
                <div className="text-sm font-semibold text-[#0F172A]">{formatPrice(item.sell)}</div>
              </div>
            </div>
          </div>
        )) : (
          <div className="py-4 text-sm text-[#64748B]">Gold and silver prices are temporarily unavailable.</div>
        )}
      </div>
      <div className="px-4 py-2 text-[0.65rem] text-[#64748B] bg-slate-50 border-t border-[#E2E8F0]">
        {updatedAt ? `Indicative trade rates · Updated ${new Date(updatedAt).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })}` : "Indicative rates · Updates about every 2 minutes"}
      </div>
    </section>
  );
}
